import { SegmentFragment, TransportType } from 'generated/graphql';

export const PLANE = 'PLANE';
export const TRAIN = 'TRAIN';

const appearancePriorities = {
  [PLANE]: 2,
  [TRAIN]: 1,
};
const getPriorityAppearance = (transportType) =>
  appearancePriorities[transportType] || -1;

const priorityAppearanceComparator = (a, b) =>
  getPriorityAppearance(b) - getPriorityAppearance(a);

const TransportTypeCollector = () => {
  const transportTypeSet = new Set<TransportType>();

  return {
    add({ transportTypes }: SegmentFragment) {
      transportTypes.forEach((type) => transportTypeSet.add(type));
    },
    build() {
      return [...transportTypeSet].sort(priorityAppearanceComparator);
    },
  };
};

export default TransportTypeCollector;
